import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {
  public dir = 'ltr';
  private TranslateServiceSubscription: Subscription;

  constructor(
    private _TranslateService: TranslateService,
  ) { }

  ngOnInit(): void {

     // on language change  
     if (this._TranslateService.currentLang === "ar") {
      this.dir = 'rtl'
    } else {
      this.dir = 'ltr';
    }

    this.TranslateServiceSubscription = this._TranslateService.onLangChange.subscribe(lang => {          
      if (lang.lang === "ar") {
        this.dir = 'rtl'
      } else {
        this.dir = 'ltr';
      }
    }) 
  }



  ngOnDestroy() {
    this.TranslateServiceSubscription.unsubscribe();
  }

}
